export const initialValues = {
    pesel: '',
};
